import {useState} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import Button from '../../../../../components/button';
import DotsLoading from '../../../../../components/dotsLoading';
import PageLoader from '../../../../../components/pageLoader';
import useFarmList from '../../../../../services/hookService/getFarmLists/useFarmList';
import usePostLoanValidationPayment from '../../../../../services/hookService/postLoanValidationPayment/usePostLoanValidationPayment';
import Num2persian from '../../../../../utilities/helper/convertNumToPersian';

const FarmValidation = ({
  loanGuid,
}: {
  validationPrice: number | undefined;
  loanGuid: string;
}) => {
  const farmAppUrl = process.env.REACT_APP_FARM_APP_URL;

  // ---------------- Farm list ----------------
  const [openSelectFarmBottomSheet, SetOpenSelectFarmBottomSheet] =
    useState<boolean>(false);
  const {
    data: farmListData,
    loaderRef,
    isFetchingNextPage,
    isLoading,
  } = useFarmList({permission_types: [9]});

  const {mutate: CreatePayment, isLoading: isPaymentLoading} =
    usePostLoanValidationPayment({
      loan_request: loanGuid,
      onSuccess: data => {
        window.location.href = data;
      },
      onError: error => {
        console.error('Payment failed:', error);
      },
    });

  if (isPaymentLoading) return <PageLoader />;

  return (
    <>
      <span className="text-sm text-gray-800 font-Medium">
        اعتبار سنجی مزرعه
      </span>

      <div className="flex flex-col gap-3 p-3 rounded-lg bg-gray-50">
        <span className="text-sm font-normal text-gray-600  [word-spacing:0.25em]">
          اعتبارسنجی مزرعه شما بر اساس اطلاعات مزارع و سوابق کشت‌های گذشته و
          جاری شما انجام می‌شود.
        </span>
        <div className="flex items-center gap-4">
          <Button
            variant="outline"
            size="small"
            className="bg-transparent disabled:border-gray-400 disabled:text-gray-600"
            baseStyles="flex flex-1 items-center justify-center rounded-lg transition-colors outline-none text-sm py-1"
            onClick={() => SetOpenSelectFarmBottomSheet(true)}
            disabled={!Boolean(farmListData?.length)}
            isLoading={isLoading}
          >
            <i className="ml-1 text-xl icon-namePlus-4" />
            سطح کشت
          </Button>
          <Button
            variant="outline"
            size="small"
            className="bg-transparent"
            baseStyles="flex flex-1 items-center justify-center rounded-lg transition-colors outline-none text-sm py-1"
            onClick={() => (window.location.href = `${farmAppUrl}/add-farm`)}
          >
            <i className="ml-1 text-xl icon-namePlus-4" />
            سطح مزرعه
          </Button>
        </div>
      </div>

      {/* Select farm for add cultivation in farm app */}
      <BottomSheet
        onDismiss={() => SetOpenSelectFarmBottomSheet(false)}
        open={openSelectFarmBottomSheet}
        blocking={true}
        snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
      >
        {isLoading ? (
          <DotsLoading />
        ) : (
          <div className="flex flex-col px-3 gap-3 pb-3  max-h-[80dvh]">
            {farmListData?.map(item => (
              <span
                key={item.guid}
                onClick={() => {
                  SetOpenSelectFarmBottomSheet(false);
                  window.location.href = `${farmAppUrl}/cultivation/addInputGroup/${item.guid}`;
                }}
              >
                {item.name}
              </span>
            ))}

            {/* This div acts as a sentinel for triggering infinite scroll */}
            <div ref={loaderRef} className="mt-4 text-center">
              {isFetchingNextPage ? <DotsLoading /> : null}
            </div>
          </div>
        )}
      </BottomSheet>
    </>
  );
};
export default FarmValidation;
